import { TaskResource } from './task.resource';
import { RequestResource } from 'src/app/richieste/resource/request.resource';

export class ApprovalInfoResource {
  type: string;
  process_id: string;
  status: string;
  request: RequestResource;
  task: TaskResource;

  constructor(type: string) {
    this.type = type;
  }

}

export class StateResource {
  id: string;
  type: string;
}

export class HistoricApprovalResource extends ApprovalInfoResource {
  public static readonly TYPE = 'historic';

   constructor() {
    super(HistoricApprovalResource.TYPE);

}
}

export class ApprovalResource extends ApprovalInfoResource {
  public static readonly TYPE = 'present';

   constructor() {
    super(ApprovalResource.TYPE);

}

}
